function addToCart(productId, quantity) {
    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            id: productId,
            quantity: quantity
        })
    })
    .then(response => response.json())
    .then(data => {
       var element = '<div class="mfp-bg mfp-move-horizontal cart-popup-wrapper mfp-ready"></div><div class="mfp-wrap mfp-close-btn-in mfp-auto-cursor mfp-move-horizontal cart-popup-wrapper mfp-ready" tabindex="-1" style="overflow: hidden auto;"><div class="mfp-container mfp-s-ready mfp-inline-holder"><div class="mfp-content"><div class="white-popup add-to-cart-popup popup-added_to_cart"><div class="added-to-cart"><p>Produkt został pomyślnie dodany do Twojego koszyka</p><a href="#" class="btn btn-style-link close-popup">Kontynuuj zakupy</a><a href="/cart" class="button view-cart">Zobacz koszyk</a></div><button title="Close (Esc)" type="button" class="mfp-close">×</button></div></div><div class="mfp-preloader">Loading...</div></div></div>';
      $('body').append(element);
      setTimeout(function() {
    location.reload();
}, 3000);
    });
}

